import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Collapse, Card, CardBody } from "reactstrap";
import FuelForm from "./FuelForm";
import MaintenanceForm from "./MaintenanceForm";
import TableFuel from "./TableFuel";
import TableMaintenance from "./TableMaintenance";
import Loading from "../../../components/Loading";
import CreateAppointmentsButtons from "./CreateAppointmentsButtons";
import TabsContent from "./TabsContent";
import { ToastContainer } from "react-toastify";
import myConfig from "../../../configs/config";
import axios from "axios";

function Appointments(props) {
  const [isContentFuelOpen, setOpenContentFuel] = useState(false);
  const [isContentMaintenanceOpen, setOpenContentMaintenance] = useState(true);
  const [isCollapseFuelOpen, setOpenCollapseFuel] = useState(false);
  const [openCollapseMaintenance, setOpenCollapseMaintenance] = useState(false);
  const [listFuel, setListFuel] = useState([]);
  const [listMaintenances, setListMaintenances] = useState([]);
  const [selectedCurrentDate, setSelectedCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const handleSaveFuel = (fuelData) => {
    setListFuel([...listFuel, fuelData]);
  };

  const handleSaveMaintenance = async (maintenanceData) => {
    await axios.post(myConfig.API_URL + "/scheduled_maintenance/", {
      ...maintenanceData,
      equipment: props.match.params.machine_id,
    });
    window.location.reload();
  };

  const handleSetOpenMaintenance = () => {
    setOpenCollapseMaintenance(!openCollapseMaintenance);
    setOpenContentMaintenance(true);
    setOpenContentFuel(false);
  };

  const handleSetOpenFuel = () => {
    setOpenCollapseFuel(!isCollapseFuelOpen);
    setOpenContentFuel(true);
    setOpenContentMaintenance(false);
  };

  const handChangeDate = (event) => {
    setSelectedCurrentDate(event);
  };

  const handleTimeChange = (event) => {
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let timeFormated = new Date(
      selectedCurrentDate.toLocaleDateString("en-US", options) +
        " " +
        event.target.value
    );

    setSelectedCurrentDate(timeFormated);
  };

  useEffect(() => {
    axios
      .get(
        `${myConfig.API_URL}/scheduled_maintenance/?equipment=${props.match.params.machine_id}`
      )
      .then((res) => {
        setListMaintenances(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching maintenance data:", error);
        setLoading(false);
      });
  }, []);

  const openContentFuel = () => {
    setOpenContentFuel(true);
    setOpenContentMaintenance(false);
  };

  const openContentMaintenance = () => {
    setOpenContentMaintenance(true);
    setOpenContentFuel(false);
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <CreateAppointmentsButtons
            handleSetOpenFuel={handleSetOpenFuel}
            handleSetOpenMaintenance={handleSetOpenMaintenance}
            t={props.t}
          />
          <TabsContent
            isContentFuelOpen={isContentFuelOpen}
            isContentMaintenanceOpen={isContentMaintenanceOpen}
            openContentFuel={openContentFuel}
            openContentMaintenance={openContentMaintenance}
          />
          {/* Fuel Section */}
          <div>
            {isContentFuelOpen && (
              <>
                <Collapse isOpen={isCollapseFuelOpen}>
                  <Card>
                    <CardBody className="card card-body collapse-suport">
                      <FuelForm
                        selectedCurrentDate={selectedCurrentDate}
                        onSave={handleSaveFuel}
                        t={props.t}
                        handChangeDate={handChangeDate}
                        handleChangeTime={handleTimeChange}
                      />
                    </CardBody>
                  </Card>
                </Collapse>
                {listFuel.length === 0 ? (
                  <h4 className="text-center title-appointments">
                    {props.t("Ainda não há nenhum registro")}
                  </h4>
                ) : (
                  <TableFuel listFuel={listFuel} />
                )}
              </>
            )}
          </div>

          {/* Maintenance Section */}
          <div>
            {isContentMaintenanceOpen && (
              <>
                <Collapse isOpen={openCollapseMaintenance}>
                  <Card>
                    <CardBody className="card card-body collapse-suport">
                      <MaintenanceForm
                        selectedCurrentDate={selectedCurrentDate}
                        onSave={handleSaveMaintenance}
                        t={props.t}
                      />
                    </CardBody>
                  </Card>
                </Collapse>
                {!openCollapseMaintenance &&
                  (listMaintenances.length === 0 ? (
                    <h4 className="text-center title-appointments">
                      {props.t("Ainda não há nenhum registro de manutenção")}
                    </h4>
                  ) : (
                    <TableMaintenance
                      listMaintenances={listMaintenances}
                      t={props.t}
                    />
                  ))}
              </>
            )}
          </div>
          <ToastContainer />
        </>
      )}
    </div>
  );
}

export default withTranslation()(Appointments);
